import { Modal, Space } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import GrtButton from '../../components/Web/GrtButton';
export const ConfirmTip = (props) => {
    let modal = Modal.confirm({
        // getContainer: () => {
        //     //主题换肤是在聊天页面换的
        //     return document.getElementById('grt-chat-box');
        // },
        autoFocusButton: null,
        icon: props.icon || <ExclamationCircleOutlined style={{ color: 'red' }}></ExclamationCircleOutlined>,
        title: <b>{props.title}</b> || <b>提示</b>,
        content: props.content || '',
        onOk: props.onOk || (() => {}),
        okText: props.okText || '确定',
        cancelText: props.cancelText || '取消',
        closable: props.closable || true,
        width:props.width || 500,
        style:props.style || { top: '25%'},
        footer: (
            <div style={{ textAlign: 'right' }}>
                <Space>
                    <GrtButton
                        onClick={() => {
                            if (props.onCancel) {
                                props.onCancel();
                            }
                            modal.destroy();
                        }}
                    >
                        {props.cancelText || '取消'}
                    </GrtButton>
                    <GrtButton
                        onClick={() => {
                            if (props.onOk) {
                                props.onOk();
                            }
                            modal.destroy();
                        }}
                        type="primary"
                    >
                        {props.okText || '确定'}
                    </GrtButton>
                </Space>
            </div>
        ),
        ...props
    });
};
